'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedbackMessage = FeedbackMessage;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css');

require('@ta-interaktiv/semantic-ui/semantic/dist/components/message.css');

require('@ta-interaktiv/semantic-ui/semantic/dist/components/list.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * React component that renders a message with a mail address allowing
 * readers to give feedback.
 *
 * @example
 * import React from 'react'
 * import FeedbackMessage from '@ta-interaktiv/react-feedback-message'
 *
 * class YourComponent extends React.Component {
 *  render() {
 *
 *    return (
 *      <FeedbackMessage mailTo='test@example.com' className='small blue' />
 *    )
 *  }
 * }
 *
 * @param {object} props
 * @param {string} [props.mailTo=interaktiv@tages-anzeiger.ch] The mail
 *   address to send the feedback to.
 * @param {string} [props.project=window.document.title] The name of the
 * project. Used as the mail subject. Defaults to the window title.
 * @param {string} [props.className] Additional CSS classes that should be
 * passed to both the `ui message` and the contained `ui list`.
 * @param {string[]} [props.additionalClasses] Alternative for adding classes to
 * `ui message` and `ui list`, when you don't want to use {@link className}.
 * You should use the other property, though.
 * @param {string} [props.question] Header line of the feedback message box.
 * @param {string} [props.call] Start of second line.
 * @param {string} [props.mail] Type of feedback.
 */
function FeedbackMessage(_ref) {
  var _ref$additionalClasse = _ref.additionalClasses,
      additionalClasses = _ref$additionalClasse === undefined ? [] : _ref$additionalClasse,
      _ref$question = _ref.question,
      question = _ref$question === undefined ? 'Haben Sie Anmerkungen oder einen Fehler entdeckt?' : _ref$question,
      _ref$call = _ref.call,
      call = _ref$call === undefined ? 'Wir freuen uns über Ihre ' : _ref$call,
      _ref$mail = _ref.mail,
      mail = _ref$mail === undefined ? 'Nachricht' : _ref$mail,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$mailTo = _ref.mailTo,
      mailTo = _ref$mailTo === undefined ? 'interaktiv@tages-anzeiger.ch' : _ref$mailTo,
      _ref$project = _ref.project,
      project = _ref$project === undefined ? window.document.title : _ref$project;

  return _react2.default.createElement(
    'div',
    { className: 'ui ' + additionalClasses.join(' ') + ' ' + className + ' message' },
    _react2.default.createElement(
      'div',
      { className: 'ui ' + additionalClasses.join(' ') + ' ' + className + ' list' },
      _react2.default.createElement(
        'div',
        { className: 'item' },
        _react2.default.createElement('i', { className: 'comments icon' }),
        _react2.default.createElement(
          'div',
          { className: 'content' },
          _react2.default.createElement(
            'div',
            { className: 'header' },
            question
          ),
          call,
          ' ',
          _react2.default.createElement(
            'a',
            {
              href: 'mailto:' + encodeURIComponent(mailTo) + '?subject=' + encodeURIComponent(project) },
            mail
          ),
          '.'
        )
      )
    )
  );
}
exports.default = FeedbackMessage;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/react-feedback-message/dist/index.js
// module id = 165
// module chunks = 0